/* eslint-disable wrap-iife */
(function(algolia) {
  'use strict';

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config } = algolia;

  // Extract ISO code from URL
  function extractIsoCodeFromUrl() {
    const match = window.location.pathname.match(/\/en-(\w\w)(\/|$)/);
    return match ? match[1] : null;
  }

  // Construct filter string based on ISO code
  function constructFilterForIsoCode(isoCode) {
    const capitalizedIsoCode = isoCode ? isoCode.toUpperCase() : '';
    return capitalizedIsoCode ? `NOT tags:do_not_sell_to_${capitalizedIsoCode}` : '';
  }

  // Filters for stock policy
  let stockPolicyFilter = '';

  if (algolia.config.stock_policy === 'deny') {
    // For 'deny' we will filter out all items based on inventory quantity
    stockPolicyFilter = 'inventory_quantity > 0';
  } else if (algolia.config.stock_policy === 'continue') {
    /**
     * For 'continue' we will filter on `inventory_available` attribute whose
     * value is dependent on:
     * `inventory_quantity > 0 OR inventory_policy == 'continue'`
     */
    stockPolicyFilter = 'inventory_available:true';
  }

  algolia.productsPlugin = {
    getSources({ query, setContext }) {
      // Extract ISO code and construct filter
      const isoCode = extractIsoCodeFromUrl();
      const isoCodeFilter = constructFilterForIsoCode(isoCode);

      // Combine filters
      const combinedFilters = [stockPolicyFilter, isoCodeFilter].filter(Boolean).join(' AND ');
      return [
        {
          sourceId: 'products',
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'products',
                  query,
                  params: {
                    hitsPerPage: 8,
                    clickAnalytics: config.analytics_enabled,
                    filters: combinedFilters,
                    distinct: algolia.config.show_products
                  },
                },
              ],
              transformResponse({ results, hits }) {
                window.SDG.Data.autocompleteProducts = hits;
                setContext({
                  nbProducts: results[0].nbHits,
                });
                return hits;
              },
            });
          },
          templates: {
            item({ item }) {
              const distinct = config.show_products;
            },
          },
        }
      ];
    },
  }
})(window.algoliaShopify);
